import { Loader, LoaderType } from '@progress/kendo-react-indicators';
import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

interface CpsLoaderProps {
  type?: LoaderType;
  textMessageKey?: string;
}

const CpsLoader: React.FC<CpsLoaderProps> = props => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  return (
    <Dialog className={`cpsLoader ${!props.textMessageKey ? 'cpsLoader--no-background' : ''}`}>
      <Loader size="large" type={props.type || 'converging-spinner'} />
      {props.textMessageKey && <div className="cpsLoaderText">{translate(props.textMessageKey)}</div>}
    </Dialog>
  );
};

export default CpsLoader;
